var common = require("../../utiles/common")
function viewModelWecom(params) {
    var $this = this;
    $this.wecomUrl = ko.observable("/public/images/loading_scan.png");
    $this.expire = ko.observable(false);
    $this.wecomStatus = ko.observable("QRCODE_SCAN_INIT");
    var work = localStorage.getItem("network") ? localStorage.getItem("network"): 0;
    $this.network = ko.observable(work == 1 ? true : false);
    $this.key = params.key;
    
    $this.timeLoop = function(url) {
        if(window.location.hash.split("?")[0] === "#/login"){
            setTimeout(function() {
                $this.qrLoop(url);
            },2000)
        }
    }

    $this.qrLoop = function(url){
        var redirectUrl = encodeURIComponent(window.location.href.split("?")[1]);
        var loopUrl = url + "&redirectUrl=" + redirectUrl;
        common.fetch(loopUrl, {
            type: "GET",
            async:true,
            handleError: function (data) {
                console.log(data)
            },
            success: function (result) {
                console.log(result)
                switch (result.state) {
                    case 'QRCODE_SCAN_SUCC':
                        window.location.href = result.redirectUrl
                        return false;
                    case 'QRCODE_SCAN_ERR':
                        $this.expire(true);
                        return false;
                    case 'QRCODE_SCAN_NEVER':
                        $this.timeLoop(url);
                        return false;
                    case 'QRCODE_SCAN_FAIL':
                        $this.wecomStatus('QRCODE_SCAN_FAIL');
                        $this.timeLoop(url);
                        return false;
                    case 'QRCODE_SCAN_ING':
                        $this.wecomStatus('QRCODE_SCAN_ING');
                        $this.timeLoop(url);
                        return false;
                }
            }
        })
    }

    $this.refQr = function(){
        $this.expire(false);
        $this.wecomStatus('QRCODE_SCAN_INIT');
        $this.openCode();
    }
    $this.openCode = function(){
        var state = sessionStorage.getItem("state")?sessionStorage.getItem("state"):"";
        if($this.network() == 1){
            var data = common.fetch(params.baseUrl+params.url, {
                type: "GET",query: {state:state}});
            if (window.WwLogin) {
                window.WwLogin({
                    id: 'qrcode-container-' + $this.key(),
                    href: '',
                    agentid: data.agentid,
                    state: data.state,
                    appid: data.appid,
                    redirect_uri: data.redirect_uri+"?"+encodeURIComponent(window.location.href.split("?")[1])
                });
            }
        }else{
            var url = '/auth/qywx/scancode/code/init?prefix=' + encodeURIComponent(params.baseUrl) + '&url=' + encodeURIComponent(params.url) + '&state=' + state;
            common.fetch(url, {
                type: "GET",
                async:true,
                handleError: function (data) {
                    console.log(data)
                },
                success: function (result) {
                    console.log(result)
                    $this.wecomUrl(result.qrCodeUrl);
                    setTimeout(function(){
                        $this.qrLoop(result.loopUrl);
                    },1000)
                }
            })
        }
    }
    setTimeout(function(){
        $this.openCode();
    },200);
}
// 组件销毁时循环函数设置为undefined
viewModelWecom.prototype.dispose = function() {
    this.qrLoop = undefined;
}

module.exports = {
    register: function () {
        document.createElement('wecom')
        ko.components.register('wecom', {
            viewModel: viewModelWecom,
            template: require("./Wecom.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/template/wecom/Wecom.js
// module id = 82
// module chunks = 0